import React from 'react';

const FrontloadingPhase = ({data, onStart}) => {
  if (!data) return null;

  const {terms, topic, estimatedDurationMinutes} = data;

  return (
    <div className="lcv-frontload-panel">
      <div className="lcv-frontload-header">
        <span className="lcv-fl-badge">INTRODUCTION</span>
        <h2 className="lcv-fl-title">{topic}</h2>
        <p className="lcv-fl-subtitle">
          {terms.length} key terms &bull; Estimated duration: {estimatedDurationMinutes} min
        </p>
      </div>

      <div className="lcv-fl-grid">
        {terms.map((t, i) => (
          <div key={i} className="lcv-fl-card">
            <span className="lcv-fl-num">{i + 1}</span>
            <div className="lcv-fl-content">
              <div className="lcv-fl-term">{t.term}</div>
              <div className="lcv-fl-def">{t.definition}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="lcv-fl-buttons">
        <button className="lcv-btn-primary" onClick={onStart}>
          Start Learning
        </button>
      </div>
    </div>
  );
};

export default FrontloadingPhase;
